import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "tailwindcss/tailwind.css";

import store from './store'
Vue.prototype.$store = store;

const apiUrl = process.env.VUE_APP_API_URL;
console.log("apiUrl=="+apiUrl);

Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL;
import api from "./api/api.js";

Vue.prototype.$api = api;

Vue.config.productionTip = false

import common from "./js/common.js";
Vue.prototype.$common = common;


import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'



Vue.use(ElementUI).use(VideoPlayer)

new Vue({
	render: h => h(App),
	router
}).$mount('#app')